import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { LastViewedArticle } from '../models';

import { LastViewedArticlesActions } from './last-viewed-articles.actions';
import { selectLastViewedArticles } from './last-viewed-articles.selectors';

@Injectable()
export class LastViewedArticlesFacade {
  readonly lastViewedArticles$: Observable<LastViewedArticle[]> = this.store$.select(selectLastViewedArticles);

  constructor(private readonly store$: Store) {}

  fetchLastViewedArticles(): void {
    this.store$.dispatch(LastViewedArticlesActions.fetchLastViewedArticles());
  }

  markArticleAsViewed(globalArticleId: string): void {
    this.store$.dispatch(LastViewedArticlesActions.markArticleAsViewed({ globalArticleId }));
  }
}
